export default function NoData() {
    return <div className='report-no-data'>
        No data available.
    </div>
}